<template>
  <div class="baseCard">
    <ul class="workList">
      <li>
        <div
          class="workListLi"
          v-for="(item,index) in data"
          :key="index"
          @click="$jumpTo('/workDetail',{id:item.id,type:type})"
        >
          <div class="workListLiTop">
            <p>{{item.title}}</p>
            <span>》</span>
          </div>
          <p class="time">{{item.publishDate}}</p>
        </div>
      </li>
    </ul>
    <a-pagination
      v-model="page"
      :total="total"
      @change="changePage"
      show-less-items
    />
  </div>
</template>

<script>
import apiUrls from "@api";
export default {
  data() {
    return {
      data: [],
      page: 1,
      size: 10,
      total: 0,
      // type: "zx",
	  keyWord: '',
    };
  },

  components: {},

  created() {
	  // console.log(this.$route.query.keyword)
	  this.keyWord = this.$route.query.keyword
    // this.type = this.$route.query.type;
    this.getNewsList();
  },
   watch: {
        // 监视搜索词变化
        "$route.query.keyword"(val) {
			console.log(val)
			this.keyWord = val
            this.getNewsList();
        },
    },

  methods: {
    changePage(page) {
      this.page = page;
      this.getNewsList();
    },
    getNewsList() {
      apiUrls.getFulltext({ searchKeyword: this.keyWord, page: this.page-1, size: this.size })
        .then((res) => {
          console.log('详情',res.results);
          this.data = res.results.data;
          this.total = res.results.pager.totalElements;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.workList {
  width: 100%;
  li {
    display: inline-block;
    width: 100%;
    list-style: none;

    .workListLi {
      display: flex;
      flex-direction: column;
      margin: 10px 0px;
      cursor: pointer;
      .workListLiTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: "MicrosoftYaHeiUI";
        color: #656565;
        p::before {
          display: inline-block;
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #000;
          margin-right: 20px;
        }
      }
      .time {
        font-size: 12px;
        font-family: "MicrosoftYaHeiUI";
        color: #919191;
        padding-left: 25px;
      }
    }
  }
}
</style>